<smt-modal 
[(isActive)]="IsShowCalculatorModal" 
(acceptEvent)="DoneCalculations()"
(rejectEvent)="closeModal()"
acceptText="Ok" 
type="Calculator-model"
acceptCssClass="button primary" 
[(disableAcceptConditions)]="!hoursCalculatorForm.form.valid"
>
<div role="header">
   Hours Calculator
</div>
<div role="body">
   <ul  >
      <form #hoursCalculatorForm="ngForm">
         <li class="JobTitle-Section" *ngFor="let jobTitle of rows">
            <div class="JobTitle-Heading">
               <b> {{jobTitle.JobTitle.abbreviation}} - {{jobTitle.TargetHours}} Target Hours</b> 
            </div>
            <ng-container *ngIf="ShowVarianceWarningSection(jobTitle)">
               <div class="warning notification" >
                  <span class="icon-notification"></span>   {{ getTargetWarning(jobTitle) }} &nbsp;
               </div>
            </ng-container>
            <table role="list" class="condensed">
               <thead>
                  <tr>
                     <th>Shift Length</th>
                     <th>Staff</th>
                  </tr>
               </thead>
               <tbody>
                  <tr >
                     <td>4 hours</td>
                     <td><input class="compact" max="9999" min="0"  pattern="[0-9]{1,4}(\.[0-9]{0,3})?"
                        name="FourHoursStaff-{{jobTitle.JobTitle.id}} " [(ngModel)]="jobTitle.FourHoursStaff" type="number"
                        (keydown)="onCellKeyDown($event)">
                     </td>
                  </tr >
                  <tr>
                     <td>8 hours</td>
                     <td><input class="compact" max="9999" min="0"  pattern="[0-9]{1,4}(\.[0-9]{0,3})?"
                          name="EightHoursStaff-{{jobTitle.JobTitle.id}} " [(ngModel)]="jobTitle.EightHoursStaff" 
                          (keydown)="onCellKeyDown($event)" type="number"></td>
                  </tr>
                  <tr>
                     <td>10 hours</td>
                     <td><input class="compact" max="9999" min="0"  pattern="[0-9]{1,4}(\.[0-9]{0,3})?"
                          name="TenHoursStaff-{{jobTitle.JobTitle.id}} " [(ngModel)]="jobTitle.TenHoursStaff"
                           (keydown)="onCellKeyDown($event)" type="number" ></td>
                  </tr>
                  <tr>
                     <td>12 hours</td>
                     <td><input class="compact" max="9999" min="0"  pattern="[0-9]{1,4}(\.[0-9]{0,3})?"
                          name="TwelveHoursStaff-{{jobTitle.JobTitle.id}} " [(ngModel)]="jobTitle.TwelveHoursStaff"
                           (keydown)="onCellKeyDown($event)" type="number" ></td>
                  </tr>
                  <tr>                     
                     <td><b>Total Hours</b></td>
                     <td><input class="compact" #TotalHours ="ngModel" name="Total-{{jobTitle.JobTitle.id}} "
                          type="number" [value]="getTotalStaff(jobTitle)" 
                         readonly [(ngModel)]="jobTitle.TotalHours"  required min="0" ></td>                        
                  </tr>
                  <tr>
                     <td> 
                     </td>
                  </tr>
               </tbody>
            </table>
            <div *ngIf="TotalHours.errors" class="ng-invalid">
               <div *ngIf="TotalHours.errors.required">
               Please enter one staff value for each job title
             </div>
           </div>
         </li>
      </form>
   </ul>
</div>
</smt-modal>
